import type { JSX } from 'react';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { withPrefetchedData } from 'src/shared/prefetch';

import { BannerSwitchContainer } from './BannerSwitch';
import { MaintenanceBannerContainer } from './MaintenanceBanner';

export const BannerContainer = withPrefetchedData(
	function BannerContainer(): JSX.Element {
		return (
			<>
				<MaintenanceBannerContainer />
				{/* using ClientRender for now to avoid SSR server-caching issues with cookies in the ToS banner */}
				<ClientRender>
					<BannerSwitchContainer />
				</ClientRender>
			</>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [BannerSwitchContainer],
	},
);
